module.exports = __webpack_public_path__ + "img/profile-white.8b13c488.png";